import { render, staticRenderFns } from "./ClientsLocationTable.vue?vue&type=template&id=9d56bcb4&"
import script from "./ClientsLocationTable.vue?vue&type=script&lang=js&"
export * from "./ClientsLocationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports